import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Crown, Sparkles, Check, X } from 'lucide-react';

const UpgradeModal = ({ 
  isOpen, 
  onClose, 
  feature = "this premium feature",
  benefits = []
}) => {
  const navigate = useNavigate();

  const defaultBenefits = [
    'Unlimited access to all premium features',
    'Priority support from our team',
    'Advanced health insights & analytics',
    'Exclusive wellness content',
    'Cancel anytime, no questions asked'
  ];

  const displayBenefits = benefits.length > 0 ? benefits : defaultBenefits;

  const handleUpgrade = () => {
    onClose();
    navigate('/subscription-plans');
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <div className="flex items-center justify-center mb-4">
            <div className="w-16 h-16 bg-gradient-to-br from-healthloop-mint-400 to-healthloop-mint-600 rounded-full flex items-center justify-center">
              <Crown className="h-8 w-8 text-white" />
            </div>
          </div>
          <DialogTitle className="text-2xl text-center">
            Unlock Premium Features
          </DialogTitle>
          <DialogDescription className="text-center text-base mt-2">
            Upgrade to access <span className="font-semibold text-healthloop-mint-700">{feature}</span> and unlock your full health potential
          </DialogDescription>
        </DialogHeader>

        <div className="mt-6">
          <div className="bg-healthloop-mint-50 border border-healthloop-mint-200 rounded-lg p-4 mb-6">
            <div className="flex items-center gap-2 mb-3">
              <Sparkles className="h-5 w-5 text-healthloop-mint-600" />
              <h4 className="font-semibold text-healthloop-mint-900">Premium Benefits</h4>
            </div>
            <ul className="space-y-2">
              {displayBenefits.map((benefit, index) => (
                <li key={index} className="flex items-start gap-2 text-sm text-gray-700">
                  <Check className="h-4 w-4 text-healthloop-mint-600 mt-0.5 flex-shrink-0" />
                  <span>{benefit}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="space-y-3">
            <Button 
              onClick={handleUpgrade}
              className="w-full bg-healthloop-mint-600 hover:bg-healthloop-mint-700 text-white"
              size="lg"
            >
              <Crown className="h-4 w-4 mr-2" />
              View Premium Plans
            </Button>
            <Button 
              onClick={onClose}
              variant="ghost"
              className="w-full"
            >
              Maybe Later
            </Button>
          </div>

          <p className="text-xs text-center text-gray-500 mt-4">
            Plans start at £39.99/month • Cancel anytime
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default UpgradeModal;
